!function (d, w) {
  d.addEventListener('DOMContentLoaded', () => {
    const _prm = new URLSearchParams(location.search),
          items = d.getElementsByClassName('config-button');

    for (let item of items) {
      const btn = item.querySelector('.nav-link'),
            btn_url = new URL(btn.href);
      btn_url.search = _prm.toString();
      btn.href = btn_url.href;
    }

    Array.from(document.querySelectorAll(`#mobile-menu li`)).filter(item => !!item.querySelector(".child")).forEach(item => {
      item.querySelector(`.header__mobile-menu-child-toggle`).addEventListener("click", ()=> {
        setTimeout(setMobileMenuHeight, 250);
      })
    })

    function setMobileMenuHeight() {
      var selectors = {
          mobileMenu : document.querySelector(`#mobile-menu`),
          openedMobileMenuItem: document.querySelector(`#mobile-menu li.open`),
          openedMenuHeight: document.querySelector(`#mobile-menu li.open div.child.open`)
      }
      var menuHeight = selectors.mobileMenu.clientHeight;
      var currentMenuItemHeight = selectors.openedMobileMenuItem ? selectors.openedMobileMenuItem.clientHeight : 0;
      var currentMenuHeight = selectors.openedMenuHeight? selectors.openedMenuHeight.clientHeight : menuHeight;
      document.querySelector(`#mobile-menu`).style.minHeight = (currentMenuItemHeight  + currentMenuHeight) +  "px";
    };

  });
}(document, window);